import { render, staticRenderFns } from "./StudyMenu.vue?vue&type=template&id=a6feaf0c&"
import script from "./StudyMenu.vue?vue&type=script&lang=js&"
export * from "./StudyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports